import { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  TableSortLabel,
  Typography
} from '@material-ui/core';

const LeadsListResults = ({
  leads, onItemClick, onSort, sortDirectionTitle, sortDirectionEmail, sortDirectionDate, ...rest
}) => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sortDirection={sortDirectionTitle}>
                  <Tooltip
                    enterDelay={300}
                    title="Sort"
                  >
                    <TableSortLabel
                      active
                      onClick={() => onSort('LeadName')}
                      direction={sortDirectionTitle}
                    >
                      Lead Name
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
                <TableCell sortDirection={sortDirectionTitle}>
                  <Tooltip
                    enterDelay={300}
                    title="Sort"
                  >
                    <TableSortLabel
                      active
                      onClick={() => onSort('LeadEmail')}
                      direction={sortDirectionTitle}
                    >
                      Lead Email
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
                <TableCell sortDirection={sortDirectionTitle}>
                  <Tooltip
                    enterDelay={300}
                    title="Sort"
                  >
                    <TableSortLabel
                      active
                      onClick={() => onSort('StartDate')}
                      direction={sortDirectionTitle}
                    >
                      Start Date
                    </TableSortLabel>
                  </Tooltip>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leads.slice(0, limit).map((lead) => (
                <TableRow
                  hover
                  onClick={() => onItemClick(lead)}
                  key={lead.id}
                >
                  <TableCell>
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex'
                      }}
                    >
                      <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        {lead.firstName}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        alignItems: 'center',
                        display: 'flex'
                      }}
                    >
                      <Typography
                        color="textPrimary"
                        variant="body1"
                      >
                        {lead.email}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    {moment(lead.createdAt.toDate()).format('L')}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={leads.length}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25]}
      />
    </Card>
  );
};

LeadsListResults.propTypes = {
  leads: PropTypes.array.isRequired,
  onItemClick: PropTypes.func,
  onSort: PropTypes.func,
  sortDirectionTitle: PropTypes.string,
  sortDirectionEmail: PropTypes.string,
  sortDirectionDate: PropTypes.string,
};

export default LeadsListResults;
